import {
  fetchFashionCategory,
  //fetchFashionTrending,
  fetchFashionArrivals,
  fetchMarketList,
  fetchSpecificCategory,
  fetchProductType,
} from "./services";
import productDataFilter from "@/shared/productDataFilter";
import { structureItemData } from "/src/helpers/items";
export default {
  namespaced: true,
  state: {
    theme: [],
    category: [],
    trending: [],
    marketListData: [],
    marketDataList: {},
    marketList: [],
    isCategoryList: [],
    categoryListItems: [],
    productTypeList: [],
    filteredSortedItems: [],
  },

  actions: {
    fetchAllMarket: async ({ commit }) => {
      try {
        const data = await fetchMarketList();
        commit("setMarketListData", data);
      } catch (e) {
        console.log(e);
      }
    },
    fetchProductType: async ({ commit }, category) => {
      try {
        const payload = { id: category[0]._id };
        const data = await fetchProductType(payload.id);
        const filteredData = data.filter((e) => {
          if (e.isProductType == true) {
            return {
              name: e.name,
              id: e._id,
            };
          }
        });
        commit("setProductType", filteredData);
      } catch (e) {
        console.log(e);
      }
    },
    fetchfashionMarketCategory: async ({ commit }, id) => {
      try {
        const payload = id;
        const data = await fetchFashionCategory(payload);
        const filteredCategoryData = data.filter((e) => e.isCategory == true);
        commit("setCategoryData", filteredCategoryData);
        const result = data.filter((e) => {
          if (e.isCategory == true) {
            return {
              id: e.id,
              name: e.name,
              index: e.index,
            };
          }
        });
        commit("setisCategoryList", result);
      } catch (e) {
        console.log(e);
      }
    },
    // fetchfashionTrending: async ({ commit }, marketName) => {
    //   try {
    //     const payload = {
    //       city: "Hyderabad",
    //       market: marketName,
    //     };

    //     const data = await fetchFashionTrending(payload);
    //     commit("setTrendingData", data);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },

    fetchSearchResult: async ({ commit }, payload) => {
      try {
        const data = await fetchSpecificCategory(payload);
        const result = data.data.hits.hits.map((each) => {
          return {
            ...each._source,
            _id: each._id,
          };
        });
        let resultFinal =
          await productDataFilter.methods.filterProductData(result);
        commit("setSpecificCategoryData", resultFinal);
      } catch (e) {
        console.log(e);
      }
    },
    fetchSpecificCategoryAction: async ({ commit }, payload) => {
      try {
        const data = await fetchSpecificCategory(payload);
        const result = data.data.hits.hits.map((each) => {
          return {
            ...each._source,
            _id: each._id,
          };
        });
        let resultFinal =
          await productDataFilter.methods.filterProductData(result);
        commit("setSpecificCategoryData", resultFinal);
      } catch (e) {
        console.log(e);
      }
    },
    fetchfashionArrivals: async ({ state, commit }, location_data) => {
      try {
        const marketDataList = {};
        for (const e of state.isCategoryList) {
          const payload = {
            location: {
              lat: location_data.Lat,
              lon: location_data.Lng,
            },
            distance: 1000,
            category: e.name,
          };
          const data = await fetchFashionArrivals(payload);
          marketDataList[e.name] = structureItemData(data);
        }
        await Promise.all(Object.values(marketDataList));
        for (let key of Object.keys(marketDataList)) {
          const temp = await marketDataList[key];
          marketDataList[key] = structureItemData(temp);
        }
        commit("setArrivalsData", marketDataList);
      } catch (e) {
        console.log(e);
      }
    },

    sortProducts: (context, payload) => {
      context.commit("sortProducts", payload);
    },
  },
  mutations: {
    // updateTheme(state, payload) {
    //   state.theme = payload;
    // },
    sortProducts: (state, payload) => {
      const { sort, filter } = payload;

      // Step 1: Filter categoryListItems by filter array
      let filteredItems = state.categoryListItems.filter((item) => {
        if (!filter || filter.length === 0) return true;
        const itemName = item.catalog.name.toLowerCase();
        return filter.some((f) => itemName.includes(f.toLowerCase()));
      });

      // Step 2: Sort the filtered list
      if (sort === "a-z") {
        filteredItems.sort((a, b) => a.Name.localeCompare(b.Name));
      } else if (sort === "z-a") {
        filteredItems.sort((a, b) => b.Name.localeCompare(a.Name));
      } else if (sort === "low") {
        filteredItems.sort((a, b) => +a.Price - +b.Price);
      } else if (sort === "high") {
        filteredItems.sort((a, b) => +b.Price - +a.Price);
      }

      // Update the state with the filtered & sorted items
      state.filteredSortedItems = filteredItems;
    },
    setProductType: (state, data) => {
      state.productTypeList = data;
    },
    setCategoryData: (state, data) => {
      state.category = data;
    },
    setTrendingData: (state, data) => {
      state.trending = data;
    },
    setArrivalsData: (state, data) => {
      state.marketDataList = data;
    },
    setMarketListData: (state, data) => {
      state.marketList = data;
    },
    setisCategoryList: (state, data) => {
      state.isCategoryList = data;
    },
    setSpecificCategoryData: (state, data) => {
      state.categoryListItems = data;
      state.filteredSortedItems = data;
    },
  },
};
